import { g500LitePermissionDefinition, offsegPermissionDefinition, permission } from '../const/commonConst';

export type ResponseType = [boolean, number];

/**
 * 共通ウェブポータルサービスの権限を判定する関数
 *
 * G500LiteとOffsegの権限が一致していない場合は、下位の権限に合わせる
 */
export const determinePermission = (offsegPermission: string | null | undefined, g500LitePermission: number | null | undefined): ResponseType => {
	// inputの存在チェック
	if (!offsegPermission || !g500LitePermission) {
		return [true, permission.id.unknown];
	}

	// Offsegがドライバー権限
	if (offsegPermission === offsegPermissionDefinition.driver) {
		switch (g500LitePermission) {
			case g500LitePermissionDefinition.limitDriver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.driver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.limitAdmin:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.admin:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.systemAdmin:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.sales:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.super:
				return [false, permission.id.driver];
			default:
				return [true, permission.id.unknown];
		}
	}

	// Offsegが管理者権限
	if (
		offsegPermission === offsegPermissionDefinition.admin ||
		offsegPermission === offsegPermissionDefinition.generalAdmin ||
		offsegPermission === offsegPermissionDefinition.groupAdmin
	) {
		switch (g500LitePermission) {
			case g500LitePermissionDefinition.limitDriver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.driver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.limitAdmin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.admin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.systemAdmin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.sales:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.super:
				return [false, permission.id.admin];
			default:
				return [true, permission.id.unknown];
		}
	}

	// Offsegがsales権限
	if (offsegPermission === offsegPermissionDefinition.sales) {
		switch (g500LitePermission) {
			case g500LitePermissionDefinition.limitDriver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.driver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.limitAdmin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.admin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.systemAdmin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.sales:
				return [false, permission.id.sales];
			case g500LitePermissionDefinition.super:
				return [false, permission.id.sales];
			default:
				return [true, permission.id.unknown];
		}
	}

	// Offsegがsuper権限
	if (offsegPermission === offsegPermissionDefinition.super) {
		switch (g500LitePermission) {
			case g500LitePermissionDefinition.limitDriver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.driver:
				return [false, permission.id.driver];
			case g500LitePermissionDefinition.limitAdmin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.admin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.systemAdmin:
				return [false, permission.id.admin];
			case g500LitePermissionDefinition.sales:
				return [false, permission.id.sales];
			case g500LitePermissionDefinition.super:
				return [false, permission.id.super];
			default:
				return [true, permission.id.unknown];
		}
	}

	return [true, permission.id.unknown];
};
